<template>
    <div class="productwecom">
      <!--banner-->
      <div class="banner outer">
        <div class="inside1490">
           <h1 class="banner_title">易猎云企微助手
            <!-- <span class="banner_rpo">RPO版</span> -->
           </h1>
           <p class="banner_txt">基于企业微信的招聘类扩展程序，可实现微信好友与<br/>简历自动关联，沟通中完成招聘工作，提高招聘效率</p>
        </div>
      </div>
        <!--图片文字排版1-->
        <div class="outer">
                <div class="inside1490 textimgbox">
                <img
                    class="fl"
                    style="width: 768px;height: 442px;margin-top: 122px;"
                    src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/wecom/pic_01%402x.png"
                />
                <div class="fr">
                    <h2>搭建企微好友简历库</h2>
                    <p class="text_detail">微信好友与简历库数据自动匹配<br/> 查看好友原始简历、标准解析简历<br/> 同步候选人的保护状态</p>
                </div>
                </div>
            </div>
      <!--清除浮动-->
      <div class="clear"></div>
        <!--文字图片排版2-->
        <div class="outer">
        <div class="inside1490 imgtextbox">
          <div class="fl">
            <h2 style="text-align: left">企微内职位展示及推荐</h2>
            <p class="text_detail">支持为企微好友匹配职位<br/> 查看招聘系统职位详情信息<br/> 可查询职位下面试、入职安排</p>
          </div>
          <img
            class="fr"
            style="width: 768px;height: 442px;margin-top: 120px;"
            src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/wecom/newpic_02%402x.png"
          />
        </div>
      </div>
      <!--清除浮动-->
      <div class="clear"></div>
       <!--图片文字排版1-->
       <div class="outer">
        <div class="inside1490 textimgbox">
            <img
                class="fl"
                style="width: 768px;height: 442px;margin-top: 122px;"
                src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/wecom/new_pic_03%402x.png"
            />
            <div class="fr">
                <h2>聊天版招聘系统</h2>
                <p class="text_detail">支持沟通中为候选人安排面试<br/> 候选人评价、备注同步招聘系统<br/> 电话一键外呼、通话、聊天数据云端存储</p>
            </div>
        </div>
            </div>
      <!--清除浮动-->
      <div class="clear"></div>
      <div class="security outer">
          <div class="inside1490 security_child">
            <div class="security_left"><img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_customer_service%402x.png"/></div>
            <div class="security_right">
              <p class="p1">即刻开启数字化招聘人效提升之旅</p>
              <!-- <div class="security_center" @click="trial()">申请试用</div> -->
            </div>
           
          </div>
      </div>
       <!--申请试用组件-->
    <populone v-if="windowflags" :isshow="windowflags" :selectId="''" :he="true" @handleChange="changewindows" />
    </div>
</template>
<script>
  import populone from "@/components/views/popul/populone";
  export default {
    name: "productwecom",
    data() {
        return{
            windowflags: false,
        }
    },
    components: {
        populone,
    },
    methods:{
      trial(){
        this.windowflags = true;
        },
        changewindows(value) {
         this.windowflags = value;
        },
    },
    metaInfo: {
        title: '易猎云企微助手-易猎云旗下产品',
        meta: [
          {
            name: 'keywords',
            content: '易猎云企微助手，企微打通，企微自动标签'
          },
          {
            name: 'description',
            content: '基于企业微信的招聘类扩展程序，可实现微信好友与简历自动关联，沟通中完成招聘工作，提高招聘效率'
          }
        ]
    },
}
</script>
<style lang="less" scoped>
@import "~@/assets/css/style/index.less";
.productwecom{
    margin-top: 85px;
    .banner {
      width: 100%;
      height: 730px;
      background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/wecom/banner_assistant%402x.png');
      background-repeat: no-repeat;
      background-size: 100%;
      padding-top: 230px;
      box-sizing: border-box;
      background-position: 0;
      .banner_title{
        font-size: 60px;
        color: #1D2754;
        line-height: 112px;
      }
      .banner_rpo{
        display: inline-block;
        width: 80px;
        height: 34px;
        border-radius: 7px;
        border: 1px solid #5666FF;
        font-size: 20px;
        color: #5666FF;
        line-height: 34px;
        text-align: center;
        vertical-align: top;
        margin-top: 30px;
      }
      .banner_txt{
        font-size: 24px;
        color: #3A4D70;
        line-height: 40px;
      }
    }
     .textimgbox {
      width: 1490px;
      height: 610px;
      border-bottom: solid 1px #E4E6EE;
      h2 {
        font-size: 42px;
        margin-top: 126px;
        font-weight: 500;
        color: #1d2754;
        line-height: 48px;
      }
      .text_detail{
        width: 453px;
        font-size: 24px;
        color: #7087A6;
        line-height: 42px;
        margin-top: 31px;
      }
    }
    .imgtextbox {
      width: 1490px;
      height: 610px;
      border-bottom: solid 1px #E4E6EE;
      h2 {
        font-size: 42px;
        margin-top: 120px;
        font-weight: 500;
        color: #1d2754;
        line-height: 48px;
      }
      .text_detail{
        width: 408px;
        font-size: 24px;
        color: #7087A6;
        line-height: 42px;
        margin-top: 31px;
      }
    }
    .clear {
      clear: both;
    }
    .security{
      width: 100%;
      height: 277px;
      background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/bg_01%402x.png');
      background-repeat: no-repeat;
      background-size: 100% 102%;
      padding-top: 53px;
      box-sizing: border-box;
      .security_child{
        display: flex;
        .security_left{
            margin-left: 197px;
              img{
                width: 145px;
                height: 128px;
              }
        }
        .security_right{
             margin-left: 37px;
              .p1{
              display: inline-block;
              font-size: 48px;
              font-weight: 500;
              color: #ffffff;
              text-align: left;
              margin-top: 47px;
          }
        }
        .security_center{
          width: 158px;
          height: 66px;
          background: #FFFFFF;
          border-radius: 7px;
          line-height: 66px;
          text-align: center;
          font-size: 24px;
          color: #215FFF;
          cursor: pointer;
          margin: 0 auto;
          margin-top: 40px;
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/product/productwecom.vue